export default class Modal {
    constructor() {
        this.header = document.querySelector('.header');
        this.buttons = document.querySelectorAll('.modal__button');
        this.closeButtons = document.querySelectorAll('.modal__close');
        this.megaMenu = document.querySelectorAll('.mega-menu-link');
        this.buttonsHover = document.querySelectorAll('.modal__button-hover');
        this.modalBg = document.querySelector('.modal__bg');
        this.logo = document.querySelector('.header__logo');
        this.baseLogo= this.logo.src;
        this.baseWidth= this.logo.width;
        this.imagesBase = this.baseLogo.substring(0, this.baseLogo.lastIndexOf('/') + 1);
        this.srcList = {
          'default': 'logo-uplix.svg',
          'data': 'logo-data.svg',
          'seo': 'logo-seo.svg',
          'media': 'logo-media.svg',
          'geo': 'logo-geo.svg',
        }
        this.srcSize = {
          'default': '52',
          'data': '120',
          'seo': '107',
          'media': '131',
          'geo': '110',
        }

        this.toggleModal = this.toggleModal.bind(this);
        this.closeModals = this.closeModals.bind(this);
        this.onResize = this.onResize.bind(this);

        this.modalBg.addEventListener('click', this.closeModals)
        
        this.buttons.forEach((el) => {
            el.addEventListener('click', this.toggleModal)
        })
        this.closeButtons.forEach((el) => {
          console.log('el', el);
            el.addEventListener('click', this.closeModals)
        })

        // if url paramater ?modal=id open modal ID
        const urlParams = new URLSearchParams(window.location.search);
        const modalParam = urlParams.get('modal');
        if (modalParam) {
            const targetModal = document.querySelector(`#${modalParam}`);
            if (targetModal) {
                this.toggleModal('url', modalParam);
            }
        }

        this.onResize()
        window.addEventListener('resize', this.onResize)
    }

    onResize() {
        this.buttonsHover.forEach((el) => {
            this.closeModals.bind(this)
            if (window.innerWidth > 1079) {
              el.addEventListener('mouseenter', this.toggleModal)
              el.addEventListener('mouseleave', this.closeModals)
            } else {
              el.addEventListener('click', this.toggleModal)
              if (el.classList.contains('noPreOpen')) {
                // do nothing
              } else {
                el.click();
              }
              this.logo.src = this.baseLogo
              this.logo.width = this.baseWidth
              this.logo.style.maxWidth  = this.baseWidth + 'px'
              this.logo.style.width  = this.baseWidth + 'px'
            }
        })
        if (window.innerWidth < 1079) {
          this.megaMenu.forEach((el) => {
            if (el.classList.contains('pointer-events-none')) {
              el.addEventListener('click', (e) => {
                e.preventDefault()
              })
            }
          })
        }
    }

    toggleModal(e, target) {
        const currentTarget = target || e.currentTarget
        // console.log('modal', e, target)
        if(e === 'url' || e.target.hasAttribute('data-modal')) {

            if (e && e !== 'url') {
                e.preventDefault()
                // console.log('tyest', e, currentTarget)
            }
            let modalSelector = null
            if (e === 'url' && target) {
              modalSelector = "#"+target
            } else {
              const logo = currentTarget.getAttribute('data-theme');
              if (logo) {
                this.logo.src = this.imagesBase + this.srcList[logo]
                this.logo.width = this.srcSize[logo]
                this.logo.style.maxWidth = this.srcSize[logo] + 'px'
                this.logo.style.width = this.srcSize[logo] + 'px'
              }
              modalSelector = currentTarget.getAttribute('data-modal')
              currentTarget.classList.toggle('active')
              const elem = document.querySelector(modalSelector)
              if (!currentTarget.classList.contains('header__item') && elem) {
                this.modalBg.classList.toggle('active')
              }
              if (elem) {
                this.header.classList.toggle('active')
              }
            }
            const modal = document.querySelector(modalSelector)
            console.log('modalSelector', modalSelector, modal)
            if (modal) {
              modal.classList.toggle('open')
              if (!modal.classList.contains('open')) {
                this.logo.src= this.baseLogo;
                this.logo.width= this.baseWidth;
                this.logo.style.maxWidth  = this.baseWidth + 'px'
                this.logo.style.width  = this.baseWidth + 'px'
              }
            }
        }
    }

    closeModals(e) {
        console.log('close modals')
        document.querySelectorAll('.modal').forEach((el) => {
            el.classList.remove('open')
        })
        document.querySelectorAll('.modal__button, .modal__button-hover').forEach((el) => {
            el.classList.remove('active')
        })
        this.modalBg.classList.remove('active')
        this.header.classList.remove('active')
        this.logo.src= this.baseLogo;
        this.logo.width= this.baseWidth;
        this.logo.style.maxWidth  = this.baseWidth + 'px'
        this.logo.style.width  = this.baseWidth + 'px'
    }
}
